import { jsx as _jsx } from "react/jsx-runtime";
import { Text } from "@miro-site/core";
import React from "react";
var Description = function(props) {
    return /*#__PURE__*/ _jsx(Text, {
        $variant: "p1",
        $transparency: 0.3,
        $align: "center",
        $mx: "auto",
        $styles: {
            maxWidth: [
                null,
                800,
                800,
                800
            ]
        },
        children: props.children
    });
};
export default Description;
